module.exports = __webpack_public_path__ + "static/media/pycharm_big.4f06afc0.png";